module.exports = __webpack_public_path__ + "img/p18.7e42a68f.png";